export default "__VITE_ASSET__DhRWfmoP__"